import { hero } from "../utils";

function Hero() {
  return (
    <div className="min-h-screen flex flex-col" id="home">
      <section className="h-screen w-full bg-gradient-to-t from-[#473D3D] via-[#28262B] to-[#28262B] flex items-center justify-start relative overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img src={hero} alt="" className="w-full h-full object-cover" />

          {/* 🔹 Mobile: dunkler Overlay mit Blur */}
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm md:hidden" />

          {/* 🔹 Desktop: Verlauf von links */}
          <div className="absolute inset-0 hidden md:block bg-gradient-to-r from-black/95 via-black/5 to-black/10" />
        </div>

        {/* Content */}
        <div className="flex flex-col items-start gap-6 max-w-5xl mb-10 px-6 sm:px-8 md:ml-16 relative z-10">
          <div className="flex flex-col gap-3 mt-32 sm:mt-40">
            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight">
              Wellness Spa
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white max-w-[35rem]">
              Auf der Suche nach einer professionellen Webseite? Bei uns sind
              Sie richtig!
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <a href="#über-uns">
              <button
                className="w-full sm:w-auto px-5 py-3 text-white text-base sm:text-lg font-medium relative overflow-hidden rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-gray-500/20
                  before:content-[''] before:absolute before:inset-0 before:z-0 before:bg-gradient-to-r before:from-white before:to-gray-700 before:rounded-xl
                  after:content-[''] after:absolute after:inset-[2px] after:z-10 after:bg-[#28262B] after:rounded-lg hover:after:bg-[#373438]"
              >
                <span className="relative z-20 whitespace-nowrap">
                  Mehr Erfahren
                </span>
              </button>
            </a>

            <a
              href="https://www.treatwell.at/ort/oase-salon-massage-kosmetik-fusspflege/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                className="w-full sm:w-auto px-[1.1rem] py-[.8rem] text-white text-base sm:text-lg font-medium 
                  bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-500 
                  transition-all duration-300 shadow-lg shadow-green-400/30 hover:shadow-green-700/100
                  rounded-xl"
              >
                <p className="whitespace-nowrap">Jetzt Buchen</p>
              </button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Hero;
